const config = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID_QA,
    authority: process.env.REACT_APP_AUTHORITY_QA,
    redirectUri: process.env.REACT_APP_REDIRECT_URI_QA,
  },
}

export default config
